<app-dot-loader></app-dot-loader>
<p [style.text-align]="textAlign"><ng-content></ng-content></p>
